module.exports = __webpack_public_path__ + "static/media/gaz.80f3e1b9.svg";